const KLAVIYO_ID_SS_KEY = "KLAVIYO_ID";
export const getKlaviyoCustomerID = () => {
    var _a, _b;
    const anyWindow = window;
    if (KLAVIYO_ID_SS_KEY in sessionStorage) {
        return sessionStorage.getItem(KLAVIYO_ID_SS_KEY);
    }
    if ("_learnq" in anyWindow && "push" in anyWindow._learnq) {
        const customerID = (_b = (_a = (anyWindow)._learnq.push(['_getIdentifiers'])) === null || _a === void 0 ? void 0 : _a.$exchange_id) !== null && _b !== void 0 ? _b : "";
        if (customerID) {
            sessionStorage.setItem(KLAVIYO_ID_SS_KEY, customerID);
            return customerID;
        }
    }
    return undefined;
};
//# sourceMappingURL=klaviyo.js.map